<app-basic-page [pageTitle]="'Workspaces'">
  <button
    class="header-right"
    nz-button
    nzType="primary"
    nzSize="default"
    nz-popover
    [(nzPopoverVisible)]="isAddWorkspaceVisible"
    [nzPopoverTitle]="undefined"
    nzPopoverTrigger="click"
    [nzPopoverContent]="addWorkspaceContentTemplate"
  >
    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
    Add Workspace

    <ng-template #addWorkspaceContentTemplate>
      <div class="vertical-large">
        <div class="vertical">
          <div class="field-name">Workspace Name</div>
          <input nz-input placeholder="Workspace Name" [(ngModel)]="workspaceName" [nzSize]="'large'" />
        </div>

        <button class="right" nz-button nzType="primary" nzSize="large" (click)="onAddWorkspaceClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
          Add
        </button>
      </div>
    </ng-template>
  </button>

  <app-workspace-list></app-workspace-list>
</app-basic-page>
